let Brandfocus_data2 =[
    {
        id : 40,
        imgurl : 'img/section5/section5_2_1.jpg'
    },
    {
        id : 41,
        imgurl : 'img/section5/section5_2_2.jpg'
    },
]

export default Brandfocus_data2;